import React from 'react';

import { style, theme } from 'constants';
import { View, Button, SwitchLang, isWeb, TabNavigator, TelPickerProvider } from 'core';
import * as actions from 'actions';

import { IcoFosolLogo } from 'icons';
import { lang } from 'lang';
import Auth from './auth';
import Verify from './verfiy';
import { getCountryTeleCode } from 'utils';

const styles = style({
  logo: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center'
  },
  holder: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    paddingTop: theme.STATUSBAR_HEIGHT
  },
  login_btn: {
    width: 300,
    marginBottom: isWeb ? 280 : 50
  }
});

class Login extends React.Component {
  state = {
    value: 0,
    account: '',
    country_code: 'SA',
    use_phone: true
  };

  async componentDidMount() {
    const { country_code } = await getCountryTeleCode();
    this.setState({ country_code });
  }

  _setAccount = data => {
    this.setState(data);
  };

  render() {
    const { provide_status, verify_status } = this.props;
    const { account, use_phone, value, country_code } = this.state;
    return (
      <View style={{ flex: 1 }}>
        <TabNavigator value={this.state.value} animated initialValue={0}>
          <View style={styles.holder}>
            <SwitchLang self={this} color={theme.primary_color} />
            <View style={styles.logo}>
              <IcoFosolLogo size={isWeb ? 160 : 110} color={theme.primary_color} style={{ marginLeft: 0 }} />
            </View>
            <Button title={lang.LOG_IN} style={[styles.login_btn]} onPress={() => this.setState({ value: 1 })} />
          </View>
          <Auth
            status={provide_status}
            action={actions.sendProvideAccount}
            use_phone={use_phone}
            account={account}
            country_code={country_code}
            index={value}
            back={() => this.setState({ value: 0 })}
            onSuccess={() => this.setState({ value: 2 })}
            setAccount={this._setAccount}
            setMethod={() => this.setState({ use_phone: !use_phone, account: '' })}
          />
          <Verify
            action={actions.sendVerifyAccount}
            account={account}
            country_code={country_code}
            use_phone={use_phone}
            back={() => this.setState({ value: 1 })}
            index={value}
            status={verify_status}
          />
        </TabNavigator>
        <TelPickerProvider />
      </View>
    );
  }
}

export default Login;



// WEBPACK FOOTER //
// ./src/components/login/index.js